import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { labelPapel } from '../permissoes';

// Cada atalho carrega a área a que pertence, igual ao menu — senão a Home
// vira um atalho para "você não tem acesso a esta tela".
const FERRAMENTAS = [
  { to: '/maps',         area: 'leads',       icon: '🗺️', nome: 'Extrator Google Maps',   desc: 'Extraia leads com nome, telefone, endereço e nota.'     },
  { to: '/instagram',    area: 'leads',       icon: '📸', nome: 'Extrator Instagram',      desc: 'Perfis por nicho e cidade via hashtags.'                },
  { to: '/clientes',     area: 'clientes',    icon: '👥', nome: 'Clientes e Chamados',     desc: 'Sua carteira e os chamados abertos de cada salão.'      },
  { to: '/kanban',       area: 'kanban',      icon: '🗂️', nome: 'Kanban de Leads',        desc: 'Organize os leads por etapa do funil.'                  },
  { to: '/calculadora',  area: 'calculadora', icon: '🧮', nome: 'Calculadora de Proposta', desc: 'Monte propostas Avec em segundos e copie pro WhatsApp.' },
  { to: '/disparo',      area: 'disparo',     icon: '🚀', nome: 'Disparo em Massa',        desc: 'Mensagens únicas e humanizadas por IA.'                 },
  { to: '/agendamentos', area: 'disparo',     icon: '📅', nome: 'Disparos Agendados',      desc: 'Programe disparos semanais automáticos.'                },
  { to: '/migrador',     area: 'migrador',    icon: '🔄', nome: 'Migrador de Planilhas',   desc: 'Converta planilhas para o formato Avec via IA.'         },
];

export default function Home() {
  const navigate = useNavigate();
  const { user, pode, papel, ehDono, vinculo } = useAuth();

  // Deslogado vê tudo (é a vitrine). Logado vê só o que o papel permite.
  const ferramentas = user ? FERRAMENTAS.filter(f => pode(f.area)) : FERRAMENTAS;

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto' }}>
      <div style={{ marginBottom: '36px' }}>
        <h1 style={{ fontFamily: 'Syne, sans-serif', fontSize: '34px',
          fontWeight: '800', letterSpacing: '-0.7px', lineHeight: '1.15',
          marginBottom: '8px' }}>
          Ferramentas que<br />
          devolvem seu <span style={{ color: '#6c47ff' }}>tempo.</span>
        </h1>
        <p style={{ color: '#52526e', fontSize: '14px', lineHeight: '1.7' }}>
          Extraia leads, dispare mensagens e migre dados — tudo em um lugar.
        </p>

        {/* Quem entra como equipe precisa saber em qual conta está mexendo */}
        {user && !ehDono && vinculo?.donoEmail && (
          <div style={{ marginTop: '16px', display: 'inline-flex', alignItems: 'center', gap: '8px',
            background: 'rgba(108,71,255,0.06)', border: '1px solid rgba(108,71,255,0.2)',
            borderRadius: '10px', padding: '10px 14px', fontSize: '12.5px', color: '#52526e' }}>
            Você está na conta de <b>{vinculo.donoEmail}</b> como <b>{labelPapel(papel)}</b>.
          </div>
        )}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
        {ferramentas.map(f => (
          <div key={f.to} onClick={() => navigate(f.to)}
            style={{
              background: '#fff', border: '1px solid rgba(0,0,0,0.08)',
              borderRadius: '14px', padding: '20px 22px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
              cursor: 'pointer', transition: 'all 0.2s'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.borderColor = 'rgba(108,71,255,0.3)';
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.borderColor = 'rgba(0,0,0,0.08)';
              e.currentTarget.style.transform = 'none';
              e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06)';
            }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
              <div style={{ fontSize: '24px' }}>{f.icon}</div>
              <div>
                <div style={{ fontFamily: 'Syne, sans-serif',
                  fontSize: '14px', fontWeight: '700', marginBottom: '3px' }}>
                  {f.nome}
                </div>
                <div style={{ fontSize: '12px', color: '#52526e' }}>{f.desc}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}